import { BaseResponse } from 'domain/payload/response/BaseResponseDto';
import axiosInstance from 'config/AxiosConfig'
import { useSelector } from 'react-redux';

const AuthService = () => {
  const decodeFormWeb = async (sessionId: string): Promise<BaseResponse<any>> => {
    try {
      var request = {
        sessionId: sessionId
      }
      const response = await axiosInstance.post(
        `/v1/legacy/auth/form/decode-session`,
        request
      );

      return response.data

    } catch (error: any) {
      console.error(error.response?.data?.message);
      throw error.response?.data?.message;
    }
  };

  return { decodeFormWeb };
};

export default AuthService;